import axios from 'axios'
import { CONFIG as SiteConfig } from '@/config'

// API Server
const apiServer = axios.create({
  baseURL: SiteConfig.API_SERVER,
})

// 相關的 api
export const apiPage = data => apiServer.get('/mappage')
export const apiYear = data => apiServer.get('/mapgallery/year/')
export const apiList = data => apiServer.get('/mapgallery/list/')
export const apiTotal = data => apiServer.get('/mapgallery/total/')
export const apiBanner = data => apiServer.get('/mapbanner')
export const apiContent = data => apiServer.get('/mapgallery/detail/' + data)
export const apiKind = data => apiServer.get('/mapkind')
export const apiGallery = data => apiServer.post('/mapgallery/list', data)
export const apiCollection = data => apiServer.post('/mapgallery', data)
export const apiReport = data => apiServer.post('/mapreport', data)
